import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import ChiSiamo from './pages/ChiSiamo';
import Contatti from './pages/Contatti';
import TalentStrategy from './pages/TalentStrategy';
import MetodoHelpy from './pages/MetodoHelpy';
import PrivaPrompt from './pages/PrivaPrompt';
import SviluppoSuMisura from './pages/SviluppoSuMisura';
import Rass from './raas';
import './App.css';

const App = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/talent-strategy" element={<TalentStrategy />} />
          <Route path="/metodo" element={<MetodoHelpy />} />
          <Route path="/privaprompt" element={<PrivaPrompt />} />
          <Route path="/sviluppo-software-su-misura" element={<SviluppoSuMisura />} />
          <Route path="/raas" element={<Rass />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
};

export default App;
